<template>
    <div v-html="require('!!html-loader!@/svg/' + this.icon + '.svg')"></div>
</template>

<script>
export default {
    props: {
        icon: {
            required: true,
            type: String,
        },

        wrap: {
            default: false,
            required: false,
            type: Boolean,
        },
    },

    mounted() {
        if (this.$el.className) {
            this.$el.firstChild.classList.add(...this.$el.className.split(' '));
        }

        if (!this.wrap) {
            this.$el.outerHTML = this.$el.innerHTML;
        }
    },
};
</script>
